export default __webpack_public_path__ + "static/media/brandIcon.ac21c50e.svg";